export enum FieldModes {
  Edit,
  Read,
  Create
}